export default "__VITE_ASSET__stC2ZCKU__"